<template>
  <el-container>
  <el-aside width="200px" style="background-color: #FFFFFF"><Manage></Manage></el-aside>
  <el-container>
    <el-header style="height:50px;padding: 0"><headTop></headTop></el-header>
    <el-main style="padding: 0; overflow-y: hidden"><Home></Home></el-main>
  </el-container>
</el-container>
</template>

<script>
  import Home from "@/components/Home.vue"
  import Manage from "@/components/Manage.vue"
  import headTop from "@/components/headTop.vue"
export default {
  name: "HomeView",
  components: {
    		Home,
    Manage,
    headTop
    	},
}
</script>

<style lang="less">
//.el-header {
//  height: 30px;
//  padding: 0;
//}
 .el-main {
         overflow-y: hidden;
       }
.body {
  margin: 0 !important;
}
</style>